import React from "react";
export var SaveMandColumn = [
    {
        columnName: "Ref Id",
        key: "RefId",
    },
    {
        columnName: "Client Code",
        key: "ClientCode",
    },
    {
        columnName: "Reason Of failure",
        key: "Reason",
    },
    {
        columnName: "On Date",
        key: "OnDate",
    },
];
export var MandatesColumn = [
    {
        columnName: "Send To Email",
        key: "raEmail",
    },
    {
        columnName: "MandateId",
        key: "mandateId",
    },
    {
        columnName: "ClientId",
        key: "clientId",
    },
    {
        columnName: "Client Name",
        key: "clientName",
    },
    {
        columnName: "Bank Name",
        key: "bankName",
    },
    {
        columnName: "Bank Account No",
        key: "bankAccNo",
    },
    {
        columnName: "Branch Name",
        key: "branchName",
    },
    {
        columnName: "Amount",
        key: "amount",
    },
    {
        columnName: "Source",
        key: "source",
    },
    {
        columnName: "Mandate Type",
        key: "mandateType",
    },
    {
        columnName: "Request Date",
        key: "reqDate",
    },
    {
        columnName: "Mandate Date",
        key: "mand_Date",
    },
    {
        columnName: "Status",
        key: "status",
        tdCustomFunction: function (key) {
            return React.createElement("span", { className: "txt_bloodRed" }, key);
        },
    },
    {
        columnName: "Scan Image",
        keysForCustomFunction: ["scanCopy", "scanCopyFileName"],
        tdCustomFunction: function (key) {
            if (key[0] !== "NA")
                return (React.createElement("a", { className: "midnight-blue-underline", download: key[1], href: key[0] }, "image link"));
            else
                return React.createElement(React.Fragment, null);
        },
    },
];
export var MandatesRows = [
    {
        sendEmail: "rohitn.pillai@nuvama.com",
        mandateId: "580595",
        clientId: "EX435982",
        clientName: "Rohit Pillai",
        bankName: "ICICI Bank",
        bankAcc: "003401038657",
        branchName: "Andheri",
        amount: "50,000",
        source: "CIP",
        mandateType: "X-Mandate",
        requestDate: "29 Apr 2017 14:37:25:450",
        mandateDate: "NA",
        status: "Rejected",
        scanimage: "imagelink",
    },
    {
        sendEmail: "25,000",
        mandateId: "Ratnakar Bank",
        clientId: "22244400239334",
        clientName: "24 Jan 2023 2:30PM",
        bankName: "2223330037238824",
        bankAcc: "WKWKWK8373737",
        branchName: "25,000",
        amount: "Ratnakar Bank",
        source: "22244400239334",
        mandateType: "24 Jan 2023 2:30PM",
        requestDate: "2223330037238824",
        mandateDate: "WKWKWK8373737",
        status: "Rejected",
        scanimage: "imagelink",
    },
];
